var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardPlayerPlayBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.372,
    height: 21.846,
    viewBox: "0 0 20.372 21.846",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_11",
    "data-name": "Polygon 11",
    d: "M10.75,0,21.5,20H0Z",
    transform: "matrix(-0.017, 1, -1, -0.017, 20.372, 0.349)",
    fill: "#a8a8a8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardPlayerPlayBtn);
export default __webpack_public_path__ + "static/media/dashboard-player-play-btn.388fb419.svg";
export { ForwardRef as ReactComponent };